// Where a client fork's own view of a field (./fieldViews.js) sits on the work item screen: loaded on
// demand, and a view that fails says so in its place — the rest of the work item keeps working.
import React, { Suspense, useState } from 'react';

class Boundary extends React.Component {
  constructor(props) { super(props); this.state = { err: null }; }

  static getDerivedStateFromError(err) { return { err }; }

  render() {
    if (!this.state.err) return this.props.children;
    return <div className="field-view-error" style={{ padding: '8px 10px', color: '#b42318', fontSize: 13 }}>This field could not be shown ({String((this.state.err && this.state.err.message) || this.state.err)}).</div>;
  }
}

export default function FieldViewHost({ View, ...props }) {
  return (
    <Boundary>
      <Suspense fallback={<div className="field-view-loading" style={{ padding: '8px 10px', color: '#6a797a', fontSize: 13 }}>Loading…</div>}>
        <View {...props} />
      </Suspense>
    </Boundary>
  );
}

const TOGGLE = { background: 'none', border: 0, padding: 0, margin: 0, font: 'inherit', color: 'inherit', letterSpacing: 'inherit', textTransform: 'inherit', cursor: 'pointer', display: 'inline-flex', alignItems: 'center', gap: 6 };

// The field with a view, on the screen: the view's own label (else the field's name) and, when the view
// asks for it, a label that folds it away and opens it again — remembered in this browser. The view is
// drawn the first time it is open and then kept (hidden while folded), so nothing being worked on is lost.
export function FieldViewSection({ className, fieldKey, label, collapsible, marks, children }) {
  const store = `stride:field-view:${fieldKey}:folded`;
  const [folded, setFolded] = useState(() => {
    if (!collapsible) return false;
    try { return window.localStorage.getItem(store) === '1'; } catch { return false; }
  });
  const [drawn, setDrawn] = useState(!folded);
  const toggle = () => {
    const next = !folded;
    setFolded(next);
    if (!next) setDrawn(true);
    try { window.localStorage.setItem(store, next ? '1' : '0'); } catch { /* this browser keeps nothing */ }
  };
  return (
    <div className={className}>
      <div className="screen-field-label">
        {collapsible ? (
          <button type="button" className="field-view-toggle" style={TOGGLE} aria-expanded={!folded} onClick={toggle} title={folded ? 'Open' : 'Fold away'}>
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" style={{ transform: folded ? 'rotate(-90deg)' : 'none', transition: 'transform .15s' }}>
              <path d="M6 9l6 6 6-6" />
            </svg>
            <span>{label}</span>
          </button>
        ) : label}
        {marks}
      </div>
      {drawn && <div hidden={folded}>{children}</div>}
    </div>
  );
}
